import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import _ from "lodash";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  INSTANCE_URL,
  NEW_IMAGE_PATH,
  BASE_IMAGES_URL,
} from "Constants";
import {
  uploadExhibitorFile,
  fetchExhibitorFileList,
} from "ActionsExhibitorsFile";
import {
  fetchExhibitors,
  updateExhibitorFiles,
  filesChanged,
} from "ActionsExhibitors";
import ExhibitorListItem from "./exhibitor-file-list-item";
import AllFilesDrop from "AllFilesDrop";
import LocaleStrings from "Languages";

const FILE_FIELD_NAME = "files_exhibitor";
const SELECT_FIELD_NAME = "select exhibitors";

class ExhibitorFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: [],
      filesPreview: [],
      filesToBeSent: [],
    };
    //this.onExhibitorSelected = this.onExhibitorSelected.bind(this);
    this.onClickExhibitor = this.onClickExhibitor.bind(this);
  }

  /*componentDidMount() {

    this.props.fetchExhibitors(this.props.session);
  }*/

  onDrop(acceptedFiles, rejectedFiles) {

    //var filesToBeSent=this.state.filesToBeSent;
    var filesToBeSent = acceptedFiles[0];
    var filesPreview = acceptedFiles[0].name;
    var preview = acceptedFiles[0].preview;
    //filesToBeSent.push(acceptedFiles);
    this.setState({ ...this.state, filesToBeSent, filesPreview, preview });
  }

  /*onExhibitorSelected(event) {
    if (event.target.value !== '') {
      this.props.fetchExhibitorFileList(this.props.session, event.target.value);
      this.setState({...this.state, exhibitorid: event.target.value});
    }

  }*/

  onClickExhibitor() {
    var exhibitor = this.props.initialValues;
    this.props.uploadExhibitorFile(
      this.props.session,
      exhibitor.exhibitorid,
      this.state.filesToBeSent,
      ({ success }) => {
        if (success === 1) {
          // clear dropzone
          this.props.showSuccess("File uploaded successfully");
        } else {
          showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  }

  /*renderExhibitors() {
    var exhibitors = [{exhibitorid:'', name: 'Select an option...'}, ...this.props.exhibitors ];
    return _.map(exhibitors, (exhibitor) => (
      <option key={exhibitor.exhibitorid} value={exhibitor.exhibitorid}>{exhibitor.name}</option>
    ));
  }*/

  renderList() {
    const items = _.map(this.props.exhibitorFiles.resource, (exhibitorFile) => (
      <ExhibitorListItem
        key={exhibitorFile.exhibitorfileid}
        exhibitorFile={exhibitorFile}
      />
    ));
    return items;
  }

  onFilesDrop = (index, files) => {
    let { exhibitorFilesList } = this.props;

    exhibitorFilesList[index].file = files.file ? files.file : "";
    exhibitorFilesList[index].filename = files.filename ? files.filename : "";


    this.props.updateExhibitorFiles(exhibitorFilesList);
  };

  onFileAvailable = (available) => {
    this.props.filesChanged({ ischanged: available });
  };

  otherFiles = () => {
    let { initialValues, exhibitorFilesList } = this.props;

    return _.map(exhibitorFilesList, (item, index) => {
    
      var filePreview = "";
      var fileName = "";
      var fileOld = true;
      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
        }
      }

      return (
        <AllFilesDrop
          key={`key-${index}`}
          width={350}
          height="auto"
          onFileSave={this.onFilesDrop.bind(this, index)}
          filepath={filePreview}
          onFileChnageLocally={this.onFileAvailable}
          fileName={fileName}
          fileOld={fileOld}
          className="content-files-dropbox"
          innerText={
            <div className="content-files-drop-text">
              <div>
                <img src={`${NEW_IMAGE_PATH}picture.png`} />
              </div>
              <div>
                {LocaleStrings.drag_and_drop} <br />
                {LocaleStrings.or}{" "}
                <span className="select-file">{LocaleStrings.select_file}</span>
              </div>
            </div>
          }
        />
      );
    });
  };

  render() {
    var exhibitor = this.props.initialValues;
    return (
      <div>
        <div className="dashboard-inside-container">
          <div className="form-group">
            <div className="row">
              <div className="col-md-12">
                {/* <Dropzone className="files-dropzone" onDrop={(files) => this.onDrop(files)} multiple={false}>
                    <div className="drop-zone">
                      {this.state.preview ? <div>
                        <img style={{"width":"197px","height":"197px"}} alt="" src={this.state.preview} />
                      </div> : null}

                    </div>
                  </Dropzone> */}
                {this.otherFiles()}
              </div>
            </div>
          </div>
        </div>
        {/* {
            this.props.exhibitorFiles.length>0
            ?
            <div className="dashboard-inside-container">
              <div className='exhibitor-content'>
                <table className="table exhibitor-table">
                  <thead>
                    <tr>
                      <th>File Uploaded</th>
                      <th>File Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderList()}
                  </tbody>
                </table>
              </div>
            </div>
            :''
          } */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.session,
  initialValues: state.exhibitor,
  exhibitorFiles: state.exhibitorFiles,
  exhibitorFilesList: state.exhibitorFilesList,
  acceptedFiles: state.acceptedFiles,
});

export default connect(mapStateToProps, {
  uploadExhibitorFile,
  fetchExhibitors,
  updateExhibitorFiles,
  filesChanged,
  fetchExhibitorFileList,
  showError,
  showSuccess,
})(ExhibitorFileUpload);
